import * as React from "react";
import * as PropTypes from "prop-types";
import { Provider } from "react-redux";
import { AppContainer } from "react-hot-loader";
import TranslateProvider from "./common/components/TranslateProvider";

import ReducerRegistry from "./lib/ReducerRegistry";
import Router from "./common/components/router/Router";
import { RouteInfo } from "./lib/routing";

interface AppProps {
  store: any;
  history: any;
  reducerRegistry: ReducerRegistry;
  locale: string;
  defaultRouteInfo: RouteInfo<any>;
}

export interface AppContext {
  reducerRegistry: ReducerRegistry;
}

export const AppContextTypes = {
  store: PropTypes.object,
  reducerRegistry: PropTypes.instanceOf(ReducerRegistry),
};

export default class App extends React.Component<AppProps> {
  public static childContextTypes = AppContextTypes;

  private store: any;
  private history: any;

  constructor(props: AppProps) {
    super(props);

    this.store = props.store;
    this.history = props.history;
  }

  public getChildContext(): AppContext {
    const { reducerRegistry } = this.props;
    return {
      reducerRegistry,
    };
  }

  public render() {
    return (
      <AppContainer>
        <TranslateProvider locale={this.props.locale}>
          <Provider store={this.store}>
            <Router history={this.history} defaultRouteInfo={this.props.defaultRouteInfo} />
          </Provider>
        </TranslateProvider>
      </AppContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/src/App.tsx